import { agoLine } from "./stages";
import { ukDayTime } from "./time";

/** Who is reading — the Hub, a lender desk, or an introducer (demo portals included). */
export const viewer = () => {
  const p = window.location.pathname;
  return p.startsWith("/hub") ? "hub" : p.startsWith("/lender") ? "desk" : "intro";
};

const terms = (o) => [o?.rate_pct != null ? `${o.rate_pct}%` : null, o?.term_months ? `over ${o.term_months} months` : null]
  .filter(Boolean).join(" ");
const pl = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

/**
 * The stage card's four lines — Right now, Waiting on, Next step, Last update. A desk's posted Right now update
 * wins (in its own words); otherwise they are read from the stage and the records behind it.
 */
export function nowFor(state, aud = viewer()) {
  const c = state?.ctx || {};
  const desk = aud === "desk";
  const client = aud === "intro" ? "your client" : "the client";
  const Client = client[0].toUpperCase() + client.slice(1);
  const lender = desk ? "You" : c.level === "case" && c.n > 1 ? "The lenders" : "The lender";
  const by = (intro, hub, mine) => (desk ? mine : aud === "hub" ? hub : intro);
  const docs = c.docs > 0 ? `${pl(c.docs, "document")} outstanding` : null;
  const call = ukDayTime(state?.now?.callback_at || c.callback_at, "a set time");

  let lines = {
    new: ["Connexis is preparing the case for lenders", "Connexis",
          by("We send it to the best-matched lenders", "Route it to the best-matched desks", "")],
    sent: [c.level === "case" ? `Sent to ${pl(c.n || 1, "lender")} · not opened yet` : desk ? "With you · not opened yet" : "Not opened yet",
           lender, by("A lender opens it and starts assessing", "Chase any desk that stays quiet", "Open it and start your assessment")],
    overdue: [`Past your ${c.turnaround || 3}-day turnaround`, "You", "Open it today, or pass on it"],
    quiet: [state?.sub || "No movement for a few days", "The lenders", by("We're chasing them — or ask for a decision", "Chase the desks", "")],
    in_review: [[state?.working ? (desk ? "You're working on it" : c.level === "case" ? "A lender is working on it now" : "The lender is working on it now")
                  : desk ? "You're assessing it" : `${lender} ${c.n > 1 ? "are" : "is"} assessing it`, docs].filter(Boolean).join(" · "),
                docs ? Client : lender, "A decision — terms issued, or a pass"],
    awaiting_docs: [docs || "Documents requested", Client,
                    by(`Send ${client} the upload link — once it's all in, the lender prepares terms`, "Chase the client for the paperwork",
                       "It moves to Preparing offer by itself once everything is in")],
    preparing_offer: [c.auto_prep ? "Every document in · terms being drawn up" : "Terms being drawn up", lender, by("Terms issued — we'll tell you the moment they land", "Terms issued", "Issue your terms")],
    offer_made: [`Terms issued${terms(c.offer) ? ` · ${terms(c.offer)}` : ""}`, `${Client} to decide`,
                 by(`Talk the terms through with ${client}`, "Help the client decide", "Mark how the client answers")],
    offer_accepted: [`${Client} accepted · funds being arranged`, lender, "Completion and funds released"],
    offer_declined: [`${Client} turned the terms down`, lender,
                     by("Share what would work — the lender can send new terms", "Steer the desk on new terms", "Send new terms, or pass")],
    completed: ["Funds released", "Nobody — it's done",
                by("Your fee goes on the next statement", "Pay the introducer on the next run", "Your fee is invoiced")],
    declined: [state?.sub || c.reason || (c.level === "case" ? "Every lender passed" : "The desk passed"), "Connexis",
               by("We look for another lender", "Re-home it with other desks", "Nothing — you passed")],
    withdrawn: ["Connexis took the case back", "Connexis", by("We place it with another lender", "Re-home it with other desks", "Nothing for you to do")],
  }[state?.key] || [state?.note || "", "", ""];
  const u = state?.now;
  if (u) lines = [u.key === "callback" ? `Call back booked for ${call}` : u.label, u.waiting, u.next];

  const m = c.move?.at ? c.move : null;
  const last = m ? `${m.text} · ${agoLine(m.at)}`
    : state?.moved?.at ? `${state.moved.who} · ${agoLine(state.moved.at)}` : null;
  const [right, waiting, next] = lines;
  return { right, waiting, next: next || null, last };
}
